/**
 * Created by Administrador on 29/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('taxes', {
                parent: 'app',
                url: '/taxes',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "10"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/tax/taxes.html',
                        controller: 'taxesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['tax']);
                            }],
                            taxes: ['taxService','$stateParams',function(taxService,$stateParams){
                                return taxService.getTaxes($stateParams.page, $stateParams.size, true);
                            }]
                        }
                    }
                }
            })
            .state('taxNew', {
                parent: 'app',
                url: '/tax/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/tax/newEditTax.html',
                        controller: 'newEditTaxController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['tax', 'passengerType','fare']);
                    }],
                    action: [function() {
                        return "new";
                    }],
                    calculationTypes: ['calculationTypeService', function(calculationTypeService){
                        return calculationTypeService.getCalculationTypes();
                    }],
                    tax: [function(){
                        return null;
                    }],
                    currencies: ['currencyService', function(currencyService){
                        return currencyService.getCurrencies()
                    }],
                }
            })
            .state('taxEdit', {
                parent: 'app',
                url: '/tax/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/tax/newEditTax.html',
                        controller: 'newEditTaxController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['tax', 'passengerType','fare']);
                    }],
                    action: [function() {
                        return "edit";
                    }],
                    calculationTypes: ['calculationTypeService', function(calculationTypeService){
                        return calculationTypeService.getCalculationTypes();
                    }],
                    tax: ['taxService','$stateParams', function(taxService,$stateParams){
                        return taxService.getTax($stateParams.id);
                    }],
                    currencies: ['currencyService', function(currencyService){
                        return currencyService.getCurrencies()
                    }],
                }
            })
            .state('taxDelete', {
                parent: 'taxes',
                url: '/tax/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/tax/deleteTax.html',
                        controller: 'deleteTaxController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'taxId': [function() {
                                return $stateParams.id
                            }],
                            'tax': ['taxService', function(taxService) {
                                return taxService.getTax($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('taxes', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
